"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sushiCelo = void 0;
exports.sushiCelo = {
    minichef: '0x0769fd68dFb93167989C6f7254cd0D766Fb2841F',
    router: '0x1421bDe4B10e8dd459b3BCb598810B1337D56842', // UniswapV2Router02
};
